import React from "react";
import "./index.css";
import App from "./App";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { MantineProvider } from "@mantine/core";
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/tiptap/styles.css';

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <MantineProvider>
    <Router>
      <App />
    </Router>
  </MantineProvider>
);
